/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row3_MulticaInputs */

const en_mk_cmp_row3_multica = /** @type {(inputs: Mk_Cmp_Row3_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found — just an activity feed`)
};

const id_mk_cmp_row3_multica = /** @type {(inputs: Mk_Cmp_Row3_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ditemukan — feed aktivitas saja`)
};

/**
* | output |
* | --- |
* | "Not found — just an activity feed" |
*
* @param {Mk_Cmp_Row3_MulticaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row3_multica = /** @type {((inputs?: Mk_Cmp_Row3_MulticaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row3_MulticaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row3_multica(inputs)
	return en_mk_cmp_row3_multica(inputs)
});